import { apiQuestions } from '@/lib';
import { useQuery } from 'react-query';

interface useGetPatientQuestionResponsesProps {
  patientId: string;
  publicacaoId: string;
}

const useGetUsuarioResultadoQuiz = ({
  patientId,
  publicacaoId,
}: useGetPatientQuestionResponsesProps) => {
  const { data, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['patient-quizz-disparos', patientId, publicacaoId],
    queryFn: async () => {
      const res = await apiQuestions.get(
        `publicacao/resultado-by-user?userId=${patientId}&publicacaoId=${publicacaoId}`,
      );

      return res.data;
    },
    enabled: !!patientId && !!publicacaoId,
  });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
};

export default useGetUsuarioResultadoQuiz;
